import { api_createAvatarUploadURL } from '@mimir/client-common/util/api';
import type { BackendClient } from '@mimir/common/util/backendClient';
import { TaskUrgency } from '@mimir/common/async/taskPriority';
import { PrioritySemaphore } from '@mimir/common/async/prioritySemaphore';
import type UserDto from '@mimir/common/dto/userDto';
import { SimpleUploader } from '@mimir/common/upload/simpleUploader';
import { ConsoleSLogger } from '@mimir/common/log/consoleSLogger';
import Axios from 'axios';
import type { FileSetListener } from '@mimir/common/upload/uploadProgression';
import { ensurePathForLocalCopy } from '@mimir/web/desktop/ensurePathForLocalCopy';

/**
 * FIXME: Instead of this User model UserModelView from @mimir/common should be used
 *        in Vuetify client and also in the Vuex store.
 **/

export interface User extends UserDto {
  userId: string;
  tenantId: string;
  emailVerified: boolean
  roles: UserRole;
}

export interface UserRole {
  superAdmin: boolean;
  tenantAdmin: boolean;
  supportTeam: boolean;
}


export const postAvatar = async (backendClient: BackendClient, file: File, progressCb: (p: number) => void) => {
  const uploadUrlReq = await api_createAvatarUploadURL(
    backendClient,
    {
      fileName: file.name,
      contentType: 'application/x-www-form-urlencoded',
    },
  );
  const percentProgress: FileSetListener = (progress) => {
    const bytes = progress.bytes;
    const p = Math.floor(bytes.done * 100 / bytes.known);
    progressCb(p);
  };
  const fsSemaphore = new PrioritySemaphore(1);
  const logger = new ConsoleSLogger();
  const simpleUploader = new SimpleUploader(
    Axios,
    uploadUrlReq.uploadUrl,
    ensurePathForLocalCopy(file),
    file.name,
    undefined,
    fsSemaphore,
    percentProgress,
    { urgency: TaskUrgency.Default, serial: 1 },
    logger
  );
  await simpleUploader.startUpload();
};
